import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "load",
  "use": "load-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"load\"><defs><style>#load .cls-1{opacity:0}</style></defs><title>资源 2</title><g id=\"load_图层_2\" data-name=\"图层 2\"><g id=\"load_图层_1-2\" data-name=\"图层 1\"><path d=\"M11 22a11 11 0 1 1 11-11 11 11 0 0 1-11 11zm0-20a9 9 0 1 0 9 9 9 9 0 0 0-9-9z\" class=\"cls-1\" /><path d=\"M11 22a11 11 0 0 1 0-22 1 1 0 0 1 0 2 9 9 0 0 0 0 18 1 1 0 0 1 0 2z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/load.svg
// module id = 83p3
// module chunks = 6